import React from 'react';

export const muiTypographyTheme = {
  MuiTypography: {
    pxToRem: (value) => `${value / 16}rem`,
    defaultProps: {
      variantMapping: {
        desktopHXXL: 'h1',
        desktopH1: 'h1',
        desktopH2: 'h2',
        desktopH3: 'p',
        desktopH4: 'p',
        desktopH5: 'p',
        desktopP1: 'p',
        desktopP2: 'p',
        desktopP3: 'p',
        desktopP3Helper: 'p',
        mobileH1: 'h1',
        mobileH2: 'h2',
        mobileH3: 'h3',
        mobileH4: 'h4',
        mobileH5: 'h5',
        mobileP1: 'p',
        mobileP2: 'p',
        mobileP3: 'p',
        mobileHelper: 'p',
      },
    },
  },
};
